/**
 * Country to flag emoji mapping
 */

const FLAG_MAP: Record<string, string> = {
    'Italy': '🇮🇹',
    'United States': '🇺🇸',
    'South Africa': '🇿🇦',
    'Sweden': '🇸🇪',
    'Australia': '🇦🇺',
    'Switzerland': '🇨🇭',
    'Netherlands': '🇳🇱',
    'Brazil': '🇧🇷',
    'Portugal': '🇵🇹',
    'Great Britain': '🇬🇧',
    'United Kingdom': '🇬🇧'
};

/**
 * Gets the flag emoji for a country
 */
export function getCountryFlag(country: string): string {
    return FLAG_MAP[country] || '🏳️';
}
